<template>
  <div class="payPage">
    <div class="pay">
      <el-row class="centerIE">
        <el-col :span="4"><i class="el-icon-circle-check"></i></el-col>
      </el-row>
      <el-row>
        <el-col
          ><p>
            信息审核通过，请缴费！<el-button type="success" @click="payHandle" :disabled="payDisable">{{ payBtnInfo }}</el-button>
          </p></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      stepIndex: 'stepIndex',
      payHerf: 'payHerf'
    })
  },
  data() {
    return {
      payBtnInfo: '点击缴费',
      payDisable: false,
      jumpUrl: null,
      errMsg: '',
      timePay: null
    }
  },
  beforeDestroy() {
    clearInterval(this.timePay)
  },
  methods: {
    getStatus() {
      const url = '/api/signup/stepInfo?' + 'signupId=' + this.$route.query.singupId + '&bianzhi=' + this.$route.query.bianzhi
      const url2 = encodeURI(url)
      this.$axios
        .post(url2)
        .then(result => {
          this.loading = false
          const { data: res } = result
          console.log(res)
          if (res.response_code == 503) {
            this.setStep(-1)
            this.$alert('您还未登录或登录已失效请重新登录', '请登录', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push('/')
              }
            })
          }
          // 已支付，待复审
          if (res.response_code == 221) {
            this.$router.go(0)
            // this.setStep(5)
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          // this.$router.push('/ApplyActive')
        })
    },
    // 缴费跳转
    ...mapMutations({
      addStep: 'ADD_STEP'
    }),
    // 缴费跳转
    payHandle() {
      console.log('前往支付')
      console.log(this.payHerf)
      window.open(this.payHerf, '_blank')
      this.jumpUrl = this.payHerf
      this.payDisable = true
      this.payBtnInfo = '正在缴费'
      this.timePay = setInterval(() => {
        this.getStatus()
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.payPage {
  .pay {
    color: #67c23a;
    i {
      font-size: 80px;
      margin-top: 50px;
      margin-bottom: 18px;
    }
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 28px;
      line-height: 50px;
    }
    .el-button {
      margin-left: 20px;
    }
  }
  @include autoInner;
}
// icon居中
.centerIE {
  transform: translate(45%);
}
</style>

